module.exports = __webpack_public_path__ + "img/avatarMale.320bf031.png";